import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-return-to-order',
  templateUrl: './return-to-order.component.html',
  styleUrls: ['./return-to-order.component.scss'],
})
export class ReturnToOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
